import React from "react";
import { BaseComponent } from "react-vextensions";
import { Row, Text } from "react-vcomponents";
import { InfoButton } from "./InfoButton.js";
export class TextPlus extends BaseComponent {
    render() {
        const { info, infoProps, sel, children, ...rest } = this.props;
        const text = React.createElement(Text, { ...rest }, children);
        if (info) {
            return (React.createElement(Row, { center: true },
                text,
                React.createElement(InfoButton, { ...infoProps, ml: 5, text: info, sel: sel })));
        }
        return text;
    }
}
//# sourceMappingURL=TextPlus.js.map